import { ButtonCSSStyleImpl } from '../../../../../toolkit/button/buttoncss';
import { Fonts } from '../../../../../../utils/resources/fonts';
import { Colors } from '../../../../../../utils/resources/colors';
export class ToneCardButtonCSSStyleImpl extends ButtonCSSStyleImpl 
{ 
    getWrapperCSSStyle(): object 
    {
       return {
        position: 'relative', 
        height: '40px', 
        width: '100%', 
        cursor: "default",
        outline:'none'
      };
    }

    getButtonStyle(): object 
    {
       return {
        width:'100%',
        height: '28px',
        float: 'left', 
        borderRadius: '0px',
        overflow: 'hidden',
        backgroundColor: this.getResources().getColor(Colors.color_5),
        cursor: "pointer",
        border: "1px solid " + this.getResources().getColor(Colors.color_2),
        alignContent: 'center',
        alignItems: "center",
        justifyContent: "center",
           
        outline:'none'

      };
    }

    getButtonText(): object 
    {
        return {
            color: this.getResources().getColor(Colors.color_2), 
            fontSize: this.getResources().getFont(Fonts.h6), 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "20px",
            textAlign: "center",
            height: "20px",
            fontWeight: "900",
            cursor: "pointer"
       };
     } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/tonecardbuttoncssstyle.ts